export default __webpack_public_path__ + "static/media/wire_frame.ad715cf1.png";